module.exports = __webpack_public_path__ + "static/media/APP_OfficeWorm_152x174_1.80b0ad9c.png";